import { render, staticRenderFns } from "./FooterWithPrevAndNextBlog.vue?vue&type=template&id=3b16c2dd&scoped=true"
import script from "./FooterWithPrevAndNextBlog.vue?vue&type=script&lang=js"
export * from "./FooterWithPrevAndNextBlog.vue?vue&type=script&lang=js"
import style0 from "./FooterWithPrevAndNextBlog.vue?vue&type=style&index=0&id=3b16c2dd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16c2dd",
  null
  
)

export default component.exports